/**
 * Brand tiles for machine makes with no products of their own.
 *
 * Several brands on the list are machine makes whose parts are sold under
 * another vendor (Ski-Doo parts are BRP's; Arctic Cat's collection is empty
 * on the store). A tile that led to an empty page would be a dead end, so
 * when the fitment data knows the make, the tile opens the finder preset to
 * it instead — "Shop by model" — and every part shown then fits. Tiles land
 * at render time and later (the menu's panels, fetched rows), so the
 * document is watched.
 */
(function () {
  'use strict';

  function upgrade() {
    const data = window.FitmentData;
    if (!data || typeof data.options !== 'function') return;
    // Makes are listed per machine type; gather them across every type.
    let makes = [];
    try {
      const types = data.options('type') || [];
      makes = [...new Set(types.flatMap((type) => data.options('make', { type }) || []))];
    } catch { return; }
    if (!makes.length) return;
    const byLower = new Map(makes.map((m) => [String(m).toLowerCase(), String(m)]));

    for (const tile of document.querySelectorAll('.brand-tile[data-brand-empty][data-brand-make]:not([data-brand-upgraded])')) {
      const make = byLower.get(tile.dataset.brandMake.toLowerCase());
      if (!make) continue;
      tile.dataset.brandUpgraded = 'finder';
      tile.setAttribute('data-garage-modal-open', '');
      tile.dataset.garageModalPreset = JSON.stringify({ make });
      const hint = tile.querySelector('[data-brand-hint]');
      if (hint) hint.hidden = false;
    }
  }

  async function boot() {
    if (window.FitmentData && typeof window.FitmentData.load === 'function') {
      try { await window.FitmentData.load(); } catch { /* no fitment data: tiles stay links */ }
    }
    upgrade();
    let timer = null;
    new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(upgrade, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.BrandTiles = { upgrade };
  if (document.readyState === 'complete') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
